import * as types from '../actions/actionTypes'; 
import initialState from './initialState';


//all the offering related reducers here
export default function (state = initialState.user, action) { //we will change the state = {} soon
  switch(action.type) {
    case types.ALL_COMMENTS_LIST_RES:
      return action.data.data
    default:
      return state
  }
}